<template>
     <v-hover>
          <v-card 
             lat tile
             v-bind="$attrs"
              v-on="$listeners"
              slot-scope="{ hover }"
                :class="`elevation-${hover ? 4 : elevation}`"
                :to="item._id"
              >
              
              <v-layout class="v-header">
                <v-flex xs2>
                  <v-btn  :to="item._id" icon>
                   <v-avatar
                      :size="avatarSize"
                      :color="`${item.logo ? 'white' : 'primary'}`"
                      class="ml-2"
                      
                    >
                      <img v-if="item.logo" v-avatar:logo :src="item.logo" alt="avatar" @error="loadError(item)">
                      <span v-else class="white--text headline">{{item.name.substring(0,1)}}</span>
                    </v-avatar>
                    </v-btn>
                </v-flex>
                <v-flex xs10>
                  <v-card-title primary-title class="pt-0 d-block">
                    <div>
                      <h4 class="title font-weight-light">{{item.name}}</h4>
                      <v-progress-linear v-model="item.score" height="1" class="card-progress"></v-progress-linear>
                      <v-layout>
                         <v-flex xs6><p class="category d-inline-flex font-weight-light">{{Math.round(item.score)}}% MATCH</p></v-flex>
                         <v-flex xs6><card-tag v-if="item.address" type="location" :tags="[{type: 'location', name: item.address.city}]" class="tag-list" :selected="selectedNames" icon="location_on"></card-tag></v-flex>
                      </v-layout>
                      </div>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-card-text class="pt-0">
                <v-layout>
                <v-flex xs2></v-flex>
                <v-flex xs5 class="pl-3">
                   <!--span :color="color(tag)" :class="{'caption grey--text': true, 'font-weight-light': true, comma: true, 'tag-item': true, highlight: dark(tag)}" v-for="(tag, index) in item.tags.filter(t=> t.type != '' && t.source !='function' && t.type != 'questions')" :key="index">{{tag.name}}</span--> 
                    <card-tag type="branche" :tags="item.tags" class="tag-list" :selected="selectedNames"></card-tag>
                   <card-tag type="category" :tags="item.tags" class="tag-list" :selected="selectedNames"></card-tag>
                     <card-tag type="type" :tags="item.tags" class="tag-list" :selected="selectedNames"></card-tag>
                </v-flex>
                 <v-flex xs5 class="pl-3">
                  
                   <card-tag type="employee" :tags="item.tags" class="tag-list" :selected="selectedNames"></card-tag>
                   <card-tag type="user" :tags="item.tags" class="tag-list" :selected="selectedNames"></card-tag>
               </v-flex></v-layout>
               <hr class="mx-3 v-divider theme--light mt-2 mb-2" v-if="item.description">
                <div class="caption grey--text font-weight-light overflow-hidden dense-text">{{item.description}}</div>
                 
               
               
                 
              </v-card-text>
              <hr class="mx-3 v-divider theme--light">
               
              <div class="v-card__actions floating">
                 
                  <v-rating :class="{'opacity-0': !hover}" v-model="item.rating" color="primary"></v-rating>
                     <v-spacer></v-spacer>
                  <v-btn flat color="orange" :class="{'opacity-0': !hover}" :to="item._id">open</v-btn>
              </div>
                <!--v-img
                 :src="banner(item.banner,`https://unsplash.it/150/300?image=${Math.floor(Math.random() * 100) + 1}`)" 
                  height="150px"
                  dark
                  class="white--text"
                   @error="loadError(item)"
                -->
                 
                   
              
          
          </v-card>
          </v-hover> 
</template>
<script>
import {
  mapGetters

} from 'vuex'

export default {
  inheritAttrs: false,

  props: {
    item: {
      type: Object,
      default: {}
    },
    elevation: {
      type: [Number, String],
      default: 1
    },
    avatarSize: {
      type: [Number, String],
      default: 48
    },
  },
  mounted ()  {
    
  },
  computed: {
    ...mapGetters('tag',['list','selectedTags','selectedNames'])
  },
  methods: {
    banner (url, def) {
      if (!url) url = def
      return this.$config.getIMageLink('banner',url,true)
    },
    loadError(item){
      item.logo = false
    },
  }
}
</script>

<style lang="scss">
.v-card .v-avatar{
    min-width:48px;
} 
.v-card .v-header {
  padding-top: 30px;
}
.card-overlay{
   /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+1,7db9e8+100 */
    background: RGBA(0,0,0,0.7); /* Old browsers */
    background: -moz-linear-gradient(top,  RGBA(0,0,0,0.7) 1%, transparent 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  RGBA(0,0,0,0.7) 1%,transparent 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  RGBA(0,0,0,0.7) 1%,transparent 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='RGBA(0,0,0,0.7)', endColorstr='transparent',GradientType=0 ); /* IE6-9 */

  }
  .card-progress{
    margin:0px;
  }
  .v-card--material {
    &__header {
      &.v-card {
        border-radius: 4px;
      }
    }
  }
  .v-btn--flat {
      height: auto;
  }
  .v-rating .v-icon {
    padding: 0.1em;
}
.v-card__actions.floating {
    position:absolute;
}
.v-card .overflow-hidden{
  max-height:40px;
  text-overflow: ellipsis;
}
.v-card p {
  margin-bottom:0;
}
.opacity-0 {
  opacity: 0;
}
.dense-text{
  line-height: 1.2em!important;
     font-size: 0.7em!important;
}
</style>